<template>
    <div>
    <el-table
      :data="tableData"
      style="width: 100%;">
      <el-table-column
        prop="labelName"
        label="Label Name"
        width="180">
      </el-table-column>
      <el-table-column
        prop="labelCode"
        label="Label Code"
        width="250">
      </el-table-column>
      <el-table-column
        prop="variable"
        label="Variable">
      </el-table-column>
    </el-table>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tableData: [
                    {
                      labelName:'申請編號',
                      labelCode:'registration_no',
                      variable:'[registration_no]',
                    },
                    {
                      labelName:'申請人姓名(中)',
                      labelCode:'applicant_chi',
                      variable:'[applicant_chi]',
                    },
                    {
                      labelName:'申請人姓名(英)',
                      labelCode:'applicant_eng',
                      variable:'[applicant_eng]',
                    },
                    {
                      labelName:'表格需要更正的内容',
                      labelCode:'need_correction_choose_content',
                      variable:'[need_correction_choose_content]',
                    },
                    {
                      labelName:'交易編號',
                      labelCode:'transaction_id',
                      variable:'[transaction_id]',
                    },
                    {
                      labelName:'交易日期',
                      labelCode:'pay_date',
                      variable:'[pay_date]',
                    },
                    {
                      labelName:'面試日期及時間',
                      labelCode:'interview_datetime',
                      variable:'[interview_datetime]',
                    },
                    {
                      labelName:'面試地點',
                      labelCode:'interview_location',
                      variable:'[interview_location]',
                    },
                    {
                      labelName:'報到地點',
                      labelCode:'report_location',
                      variable:'[report_location]',
                    },
                    {
                      labelName:'QR Code',
                      labelCode:'qr_code',
                      variable:'[qr_code]',
                    },
                ]
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>